export default __webpack_public_path__ + "static/media/library.f8e28086.svg";